import { render, staticRenderFns } from "./sloganIcon.vue?vue&type=template&id=10c416b3&scoped=true&"
import script from "./sloganIcon.vue?vue&type=script&lang=js&"
export * from "./sloganIcon.vue?vue&type=script&lang=js&"
import style0 from "./sloganIcon.vue?vue&type=style&index=0&id=10c416b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c416b3",
  null
  
)

export default component.exports